import { render, staticRenderFns } from "./IpVitana.vue?vue&type=template&id=a8977612"
import script from "./IpVitana.vue?vue&type=script&lang=js"
export * from "./IpVitana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports